// extracted by mini-css-extract-plugin
export default {"notification_container":"Notifications_notification_container__QWgpJ"};